import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';
import SignaturePad from 'react-signature-pad'

class FlightReportRefuelApprovalsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      type: false,
      reproval_modal: false,
      modal_login_approval: false,
      flight_report_refuel_id: this.props.flight_report_refuel_edit.id,
      reproved_id: null,
      reason: null,
      username: null,
      password: null,
      flight_report_refuel: this.props.flight_report_refuel,
      flight_report_refuel_approvals: this.props.flight_report_refuel_approvals,
    };

    this.locale = getLocale();
    this.clearSignature = this.clearSignature.bind(this);
    this.approval_login = this.approval_login.bind(this);
    this.reproval_login = this.reproval_login.bind(this);
    this.approval_signature = this.approval_signature.bind(this);
    this.reproval_signature = this.reproval_signature.bind(this);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.flight_report_refuel_approvals === 'undefined' || this.state.loaded !== 1) {
      this.setState({
        flight_report_refuel_id: newProps.flight_report_refuel_id,
        flight_report_refuel_approvals: newProps.flight_report_refuel_approvals,
        flight_report_refuel: newProps.flight_report_refuel,
        loaded: 1,
      });
    }
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  openLoginModal (flight_report_refuel_approval_id) {
    this.setState({modal_login_approval: true, flight_report_refuel_approval_id: flight_report_refuel_approval_id});
  }

  openReprovalModal (flight_report_refuel_approval_id) {
    this.setState({reproval_modal: true, flight_report_refuel_approval_id: flight_report_refuel_approval_id});
  }

  approval_login(event) {
    var self = this;
    event.preventDefault();
    if(window.confirm(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.Confirmacao)) {
      self.props.handleAlert('', '', 'open');
      var datasave = {
        username: this.state.username,
        password: this.state.password,
        flight_report_refuel_approval_id: this.state.flight_report_refuel_approval_id,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/abastecimento/aprovacao/login/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({modal_login_approval: false});
          self.props.updateData(responseJson);
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  reproval_login(event) {
    var self = this;
    event.preventDefault();
    if(window.confirm(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.Confirmacao)) {
      self.props.handleAlert('', '', 'open');
      var datasave = {
        username: this.state.username,
        password: this.state.password,
        flight_report_refuel_approval_id: this.state.flight_report_refuel_approval_id,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/abastecimento/aprovacao/login/reprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({modal_login_approval: false});
          self.props.updateData(responseJson);
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  approval_signature() {
    var self = this;
    var signature = this.refs.approveSignature;
    if(signature.isEmpty()) {
      window.alert(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.AlertaAssinaturaVazia);
    } else {
      self.props.handleAlert('', '', 'open');
      var datasave = {
        image: signature.toDataURL(),
        flight_report_refuel_approval_id: this.state.flight_report_refuel_approval_id,
      };
      var header = self.refs.request_api.header('application/json');
      // signature.clear();
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/abastecimento/aprovacao/login/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({modal_login_approval: false});
          self.props.updateData(responseJson);
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  reproval_signature() {
    var self = this;
    var signature = this.refs.reproveSignature;
    if(signature.isEmpty()) {
      window.alert(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.AlertaAssinaturaVazia);
    } else {
      if(window.confirm(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.Confirmacao)) {
        self.props.handleAlert('', '', 'open');
        var datasave = {
          image: signature.toDataURL(),
          flight_report_refuel_approval_id: this.state.flight_report_refuel_approval_id,
        };
        var header = self.refs.request_api.header('application/json');
        // signature.clear();
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/abastecimento/aprovacao/login/reprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({modal_login_approval: false});
            self.props.updateData(responseJson);
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }
  }

  clearSignature () {
    var reproveSignature = this.refs.reproveSignature;
    if(typeof reproveSignature !== 'undefined') {
      reproveSignature.clear();
    }
    var approveSignature = this.refs.approveSignature;
    if(typeof approveSignature !== 'undefined') {
      approveSignature.clear();
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.Titulo}</h3>
  <div className="clearfix"></div>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.tabela.Tipo}</th>
          <th>{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.tabela.Aprovacao}</th>
          <th>{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody>
      {typeof self.state.flight_report_refuel_approvals !== 'undefined' && Object.keys(self.state.flight_report_refuel_approvals).map(function(k) {
        var approval = self.state.flight_report_refuel_approvals[k];
        return (
          <tr>
            <td>{approval.type_str}</td>
            <td>{approval.user_name}</td>
            <td className="text-center">
              {
                (approval.status === 'pending') ?
                  <div>
                    <button onClick={() => {self.openLoginModal(approval.id)}} className="btn btn-success btn-sm button-inline"><i className="fa fa-check"></i></button>
                    <button onClick={() => {self.openReprovalModal(approval.id)}} className="btn btn-danger btn-sm button-inline"><i className="fa fa-close"></i></button>
                  </div>
                : (approval.status === 'approved' || approval.status === 'reproved') ?
                  <div>
                    <button className="btn btn-success btn-sm" disabled><i className="fa fa-check"></i></button>
                  </div>
                :
                  <div>
                    <button className="btn btn-danger btn-sm" disabled><i className="fa fa-close"></i></button>
                  </div>

              }
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>

  {/* Modal de justificativa de reprovação */}
  <Modal show={this.state.reproval_modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.Titulo}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({reproval_modal: false})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      {/*<h4>{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.BotaoReprovar}</h4>
      <form onSubmit={this.reproval_login}>
        <div className="form-group">
          <div className="input-group">
            <label className="input-group-addon">{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.Razao}:</label>
            <input type="text" name="reason" className="form-control" placeholder="" value={this.state.reason} onChange={this.handleChange.bind(this, 'reason')} required />
          </div>
        </div>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
            <input type="email" name="username" className="form-control" placeholder="Seu e-mail" value={this.state.username} onChange={this.handleChange.bind(this, 'username')} required />
          </div>
        </div>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
            <input type="password" name="password" className="form-control" placeholder="Sua senha" value={this.state.password} onChange={this.handleChange.bind(this, 'password')} required />
          </div>
        </div>
        <button type="submit" className="btn btn-danger btn-block btn-inline"><i className="fa fa-fw fa-close"></i> {this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.BotaoReprovar}</button>
      </form>
      <hr />*/}
      <h4 className="pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.BotaoReprovar}</h4>
      <button className="btn btn-success btn-sm pull-right" onClick={() => self.clearSignature()}><i className="fa fa-fw fa-refresh"></i></button>
      <div className="clearfix"></div>
      <hr />
      <div className="text-center">
        <SignaturePad ref="reproveSignature" />
      </div>
      <hr />
      <button type="button" className="btn btn-danger btn-block btn-inline" onClick={() => this.reproval_signature()}><i className="fa fa-fw fa-close"></i> {this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.BotaoReprovar}</button>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({reproval_modal: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

  {/* Modal de aprovação por login */}
  <Modal show={this.state.modal_login_approval} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.Titulo}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal_login_approval: false})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      {/*<h4>{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.TituloPorLogin}</h4>
      <form onSubmit={this.approval_login}>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
            <input type="email" name="username" className="form-control" placeholder="Seu e-mail" value={this.state.username} onChange={this.handleChange.bind(this, 'username')} required />
          </div>
        </div>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
            <input type="password" name="password" className="form-control" placeholder="Sua senha" value={this.state.password} onChange={this.handleChange.bind(this, 'password')} required />
          </div>
        </div>
        <button className="btn btn-success btn-block" type="submit"><i className="fa fa-fw fa-sign-in"></i> {this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.BotaoAprovar}</button>
      </form>
      <hr />*/}
      <h4 className="pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.TituloPorAssinatura}</h4>
      <button className="btn btn-success btn-sm pull-right" onClick={() => self.clearSignature()}><i className="fa fa-fw fa-refresh"></i></button>
      <div className="clearfix"></div>
      <hr />
      <div className="text-center">
        <SignaturePad ref="approveSignature" />
      </div>
      <hr />
      <button className="btn btn-success btn-block" type="button" onClick={() => this.approval_signature()}><i className="fa fa-fw fa-sign-in"></i> {this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.BotaoAprovar}</button>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal_login_approval: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default FlightReportRefuelApprovalsTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/Elements/FlightReportRefuelApprovalsTab.js